import React, { PropTypes } from 'react';
import { FormGroup, Table } from 'react-bootstrap';

const QuoteSummary = (props) => {
  return (
    <div className="ebaoUtil__Top-Bottom-Line-0">
      <FormGroup controlId="mainCoverageType">
      <Table responsive>
        <thead>
          <tr>
            <th>Gross Premium</th>
            <th>Net Premium</th>
            <th>M.I.B.</th>
            <th>IA Levy</th>
            <th>Premium Payable</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{props.grossPremium}</td>
            <td>{props.netPremium}</td>
            <td>{props.mib}</td>
            <td>{props.levy}</td>
            <td>{props.premiumPayable}</td>
          </tr>
          <tr>
            <td colSpan="6" className="text-danger">
              The premium is valid only for cases without any risk to refer to AXA.
              If special risks are involved, the premium can not be used to quote,
              and the case should be referred to underwriter
            </td>
          </tr>
        </tbody>
        </Table>
      </FormGroup>
    </div>
  )
}

QuoteSummary.propTypes = {
  grossPremium: PropTypes.number,
  netPremium: PropTypes.number,
  mib: PropTypes.number,
  levy: PropTypes.number,
  premiumPayable: PropTypes.number
};

export default QuoteSummary;



// WEBPACK FOOTER //
// ./src/app/components/quoteSummary/QuoteSummary.js